import moment from "moment";

/**
 * Plausibility check for service-reminder due dates.
 *
 * Returns `true` when `dueDate` is strictly after `referenceDate` (compared at
 * day granularity). When either date is missing there is nothing to validate, so
 * it returns `true` — empties are handled by the form's own `required` rules.
 */
export const isDueDateAfter = (dueDate?: string | null, referenceDate?: string | null): boolean => {
    if (!dueDate || !referenceDate) return true;
    return moment(dueDate).isAfter(moment(referenceDate), "day");
};
